import React from 'react';
import { motion } from 'framer-motion';
import { Instagram } from 'lucide-react';
import './SocialVideos.css';

const SocialVideos = () => {
  const videos = [
    {
      id: 1,
      platform: 'instagram',
      postId: 'DQrpHFiEf9D',
      embedUrl: 'https://www.instagram.com/reel/DQrpHFiEf9D/embed',
      title: 'Instagram Reel'
    },
    {
      id: 2,
      platform: 'instagram',
      postId: 'DSInCSVgfP8',
      embedUrl: 'https://www.instagram.com/reel/DSInCSVgfP8/embed',
      title: 'Instagram Reel 2'
    }
  ];

  return (
    <div className="social-videos-section">
      <motion.div
        className="social-videos-header"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="social-videos-title">
          <span className="title-icon">
            <Instagram size={32} />
          </span>
          Nuestro Trabajo
        </h2>
        <p className="social-videos-subtitle">
          ¡Mira nuestros mejores cortes y estilos!
        </p>
      </motion.div>

      <div className="videos-grid">
        {videos.map((video, index) => (
          <motion.div
            key={video.id}
            className="video-card"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: index * 0.2 }}
          >
            <div className="video-wrapper">
              <iframe
                src={video.embedUrl}
                className="video-iframe"
                frameBorder="0"
                scrolling="no"
                allowTransparency="true"
                allow="encrypted-media"
                title={video.title}
              />
            </div>
            <div className="video-info">
              <div className="platform-icon">
                {video.platform === 'instagram' ? (
                  <Instagram size={20} />
                ) : (
                  <span className="tiktok-icon">TikTok</span>
                )}
              </div>
              <span className="platform-name">
                {video.platform === 'instagram' ? 'Instagram' : 'TikTok'}
              </span>
            </div>
          </motion.div>
        ))}
      </div>
    </div>
  );
};

export default SocialVideos;
